module.exports = __webpack_public_path__ + "static/img/greeno.3f3fc53.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/greeno.png
// module id = CjXJ
// module chunks = 145